<script setup>
import { onClickOutside } from '@vueuse/core'
import { reactive } from 'vue'
import { ref } from 'vue'

import { useSettingsStore } from '@/stores/SettingsStore'

const { isPageSK, isPageCZ, isPageHU } =  useSettingsStore()

defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['update:modelValue'])

const state = reactive({
  isCountryDropdownOpened: false
})

const toggleDropdown = () => state.isCountryDropdownOpened = !state.isCountryDropdownOpened

const selectOption = (countryCode) => {
  toggleDropdown()
  emits('update:modelValue', countryCode)
}

const target = ref(null)

onClickOutside(target, () => state.isCountryDropdownOpened = false)

</script>

<template>
  <div ref="target" class="settings-modal--address">
    <div class="settings-modal__row">
      <div class="settings-modal__country-selector-wrapper ">
        <label class="settings-modal__country-selector-label input-label">
          {{ $t('Country') }}
        </label>
        <div id="country-selector" class="settings-modal__country-selector" @click="toggleDropdown">
            <span class="settings-modal__country-selector-value basic basic-16">
              <template v-if="isPageCZ">{{ $t('Czech Republic') }}</template>
              <template v-if="isPageSK">{{ $t('Slovakia') }}</template>
              <template v-if="isPageHU">{{ $t('Hungary') }}</template>
            </span>
          <div class="settings-modal__country-selector-arrow" :class="{'isOpen': state.isCountryDropdownOpened}">
          </div>
        </div>
        <div v-show="state.isCountryDropdownOpened"  class="settings-modal__country-selector-dropdown">
          <div class="settings-modal__country-selector-text basic change-blocked-field visible">
            <p v-html="$t('We can\'t change the delivery address on existing subscription. In case you need to change it please contact us on email.', { email: $t('email-subscription') })" />
          </div>
          <div class="settings-modal__country-selector-divider delivery-field change-blocked-field visible"></div>

          <div v-if="isPageHU" class="settings-modal__country-selector-option-wrapper" :class="{'disabled': !isPageHU}" @click="selectOption('HU')">
            <span class="settings-modal__country-selector-option link">{{ $t('Hungary') }}</span>
          </div>
          <template v-else>
            <div class="settings-modal__country-selector-option-wrapper" :class="{'disabled': !isPageSK}" @click="selectOption('SK')">
              <span class="settings-modal__country-selector-option link">{{ $t('Slovakia') }}</span>
            </div>
            <div class="settings-modal__country-selector-option-wrapper" :class="{'disabled': !isPageCZ}" @click="selectOption('CZ')">
              <span class="settings-modal__country-selector-option link">{{ $t('Czech Republic') }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>